import { render, staticRenderFns } from "./myConsumeList.vue?vue&type=template&id=5fceb270&scoped=true"
import script from "./myConsumeList.vue?vue&type=script&lang=js"
export * from "./myConsumeList.vue?vue&type=script&lang=js"
import style0 from "./myConsumeList.vue?vue&type=style&index=0&id=5fceb270&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fceb270",
  null
  
)

export default component.exports